<template>
  <div class="list-container" :style="style">
    <div class="list-row">
      <slot :gutter="gutter" :width="width" />
    </div>
  </div>
</template>
<script>
export default {
  name: 'ListRow',
  props: {
    gutter: {
      type: Number,
      default: 24
    },
    width: {
      type: Number,
      default: 100
    }
  },
  computed: {
    style() {
      return {
        marginLeft: -this.gutter / 2 + 'px',
        marginRight: -this.gutter / 2 + 'px'
      };
    }
  }
};
</script>
<style lang="scss" scoped>
.list-container {
  min-height: calc(100% - 60px);
}
.list-row {
  overflow: hidden;
}
</style>
